
    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import AbpBase from '@/lib/abpbase'
    import Util from '@/lib/util'
    import warehousequest from '@/store/entities/warehouseinfodetail'
    import getOrderStatistics from '@/store/entities/user-order-statistics'
    import DateUtils from '@/common/js/DateUtils'
    import Enums from '@/lib/enums'
    import appconst from '@/lib/appconst';
    import { routers } from '@/router/router'
     
    @Component
    export default class Home extends AbpBase {
        warehouseInfodetailList: Array<warehousequest> = [];
        getOrderStatisticsquest: getOrderStatistics = new getOrderStatistics();
        userName: string;
        mlUserName: string;
        fluserName: string;
        malaiOversName: string;
        taiguoOverName: string;
        yuenanNative: string;
        tiktokName: string="";
        phone: string = "";
        userId: string = "";
        lgName: string = "";
        isDisplay: boolean = true;
        isDisplays: boolean = false;
        async created() {
            
            var a = this.hasPermission("OrderManage.MainLandOrderManage");
            var b = this.hasPermission("OrderManage.MainLandOrderManage.FreightCost");
            if (a == true && b == false) {
                this.isDisplay = false;
            }
            else {
                await this.getpage();
            }
        }
        data() {
            return {
                split3: 0.6,
                split4: 0.7
            }
        }
        async getpage() {
            
            this.warehouseInfodetailList = await this.$store.dispatch({
                type: 'warehouseInfoDetail/getAll',
                data: {}
            });
            this.getOrderStatisticsquest = await this.$store.dispatch({
                type: 'fontorder/getOrderStatistics',
                data: {}
            });
            //this.yuenanNative = this.warehouseInfodetailList[0].userCode;
            //this.userName = this.warehouseInfodetailList[0].userCode.replace("通达", "梁智星");
            //this.mlUserName = this.warehouseInfodetailList[0].userCode.replace("通达", "刁文生");
            //this.fluserName= this.warehouseInfodetailList[0].userCode.replace("通达", "通达F");
            //this.malaiOversName = this.warehouseInfodetailList[0].userCode.replace("通达", "TDAmanda");
            //this.taiguoOverName = this.warehouseInfodetailList[0].userCode.replace("通达", "TDqiang");
            this.tiktokName = this.warehouseInfodetailList[0].userCode;
            this.userId = this.tiktokName;
            this.phone = this.warehouseInfodetailList[0].phone;
            this.lgName = this.tiktokName.replace("XLCK", "LG");
        }
        
        
    }
